import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { mailboxGuideMessages as messages } from './mailboxGuideMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the guide; each part uses its own slice of it */
import styles from './MailboxGuide.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface GuideHeadProps {
  /** 1, 2 or 3: the bars of the progress and the "Step N of 3" line (design p1 `mp-steps`). */
  step: 1 | 2 | 3;
  title: string;
  intro?: string;
}

/** The head of each guide card: the 3 progress bars with the step line, the title and one line. */
const GuideHeadComponent: React.FC<GuideHeadProps> = ({ step, title, intro }) => {
  const intl = useIntl();
  return (
    <div className={styles.head}>
      <div className={styles.stepLine}>
        <div className={styles.progress} aria-hidden="true">
          <i className={styles.progressOn} />
          <i className={step >= 2 ? styles.progressOn : undefined} />
          <i className={step >= 3 ? styles.progressOn : undefined} />
        </div>
        <span className={styles.eyebrow}>{intl.formatMessage(messages.stepOf, { step })}</span>
      </div>
      <h2 className={styles.title}>{title}</h2>
      {intro !== undefined && <p className={styles.intro}>{intro}</p>}
    </div>
  );
};

export const GuideHead = TypedMemo(GuideHeadComponent);
